<template>
    <div class="fivecity">
        <div class="home_header">
            <Swipe
                :loop="false"
                :show-indicators="false"
                width="100%"
                height="100%"
                :touchable="false"
                ref="swipeItem"
            >
                <SwipeItem v-for="(item,index) in tabs" :key="index">
                    <VanImage :src="item.imgurl" fit="cover" width="100%" height="100%">
                        <template v-slot:loading>
                        <loading type="spinner" size="20" />
                        </template>
                        <template v-slot:error>加载失败</template>
                    </VanImage>
                </SwipeItem>
            </Swipe>
        </div>
        <div class="five_body">
            <template v-if="tabs.length">
                <div class="tabs" v-if="tabs.length>1">
                    <div v-for="(item,index) in tabs" :key="item.id" class="tabcard" :class="{active:index===swiperIndex}" @click="switchTab(item.id,index)">
                        <span>{{item.title}}</span>
                    </div>
                </div>
                <div class="itemrule" @click="showRule = true"></div>
                <div class="tabbody">
                    <div class="title">
                        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20231109/1699514975/531702.png" alt="">
                        <div>{{title}}</div>
                    </div>

                    <div class="item" :style="{backgroundImage: 'url('+item.icon+')'}" v-for="item in subItemList" :key="item.id"  @click="goDetail(item)">
                        {{item.start_time_show}} ～ {{item.end_time_show}}
                    </div>
                </div>
                <!-- <SportItem
                    v-if="currentItem.id==this.$route.params.item_id"
                    :item="currentItem"
                    :matchid="matchid"
                    :detail="detail"
                ></SportItem> -->
                
            </template>
            <template v-else>
                <div class="tabbody">
                    <!-- 暂无数据 -->
                </div>
            </template>
        </div>

        <van-dialog
            v-model="showRule"
            class="sports_item_rule_dialog rule"
            :show-confirm-button="false"
            close-on-click-overlay
            >
            <van-icon
                name="close"
                style="position:fixed;right:10px;"
                size=".4rem"
                @click="showRule=false"
            />
            <div
                class="rule"
            >
                <!-- <div
                class="header"
                slot="title"
                >{{title}}</div> -->
                <div v-html="rule"></div>
            </div>
            </van-dialog>
    </div>
</template>

<script>
import "./five.less"
import { Image, Loading, Tab, Tabs, Swipe, SwipeItem } from "vant";
export default {
    data() {
        return {
            subItemList: [],
            swiperIndex: 0,
            tabs: [],
            matchid: '',
            item_id: '',
            title: '',
            rule: '',
            showRule: false
        }
    },
    components:{
        VanImage: Image,
        Loading,
        Tab,
        Tabs,
        Swipe,
        SwipeItem,
    },
    mounted() {
        this.$nextTick(() => {
            // this.initIndex();
            this.matchid = this.$route.params.matchid
            this.init()
        })

    },
    methods: {
        init: function () {
            this.$toast.loading({
                message: "加载中...",
                forbidClick: true,
                duration: 0, // 持续展示 toast
            });
            this.$api.sports.sportsMain({matchid:this.matchid}).then(
                (res) => {
                this.tabs = res.data;
                //定义 颜色
                // this.setBgColor(bgstyle.background);
                // this.$storage.set("shareInfo", shareconfig);
                this.$toast.clear();
                this.itemChange();
                if (window.__wxjs_is_wkwebview) {
                    //部分ios
                    window.scrollTo(0, 1);
                }               
                },
                (e) => {
                this.$toast.clear();
                }
            );
        },
        itemChange: function () {
            if(this.cf.isEmpty(this.item_id)){
                this.item_id = this.tabs[0]['id']
            }
            this.getItemInfo()
        },
        switchTab: function (id,index) {
            this.swiperIndex = index;
            this.$refs.swipeItem.swipeTo(index);
            this.item_id = id;
            this.getItemInfo()
        },
        getItemInfo() {
            this.subItemList = [];
            this.rule = "";
            this.enableActivity = false
            this.$api.mwap.getItemSubs({ itemid: this.item_id,matchid:this.matchid }).then((res) => {
                this.subItemList = res.data.list;
                this.title = res.data.title;
                this.rule = res.data.rule;
            });
        },
        goDetail(val) {
            if(val.jump_url) {
                if(val.jump_url.indexOf('https') != -1) {
                    window.location.href = val.jump_url
                    return
                }
                wx.miniProgram.navigateTo({
                    url:val.jump_url
                });
                return
            }
            this.$router.push({name:'sportsDetail',params:{matchid:val.match_id,item_sub_id:val.id}})
        },
    }
}
</script>
